import type { PermissionScope } from "@verbleif/lib/src/composables/Api/Type/UserPermissions/userPermission.enum";
import type { CrudArgs } from "./composables/ContextVoter";
import type { AggregateVoterCheck, ContextVoterInterface } from "./composables/ContextVoter.interface";
import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

export class AccessGrantVoter extends ContextVoter implements ContextVoterInterface {
  public canCreate: ContextVoterInterface["canCreate"] = (item) => {
    return this._canCreate({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessgrantCreateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessgrantCreate,
    });
  };

  public canRead: ContextVoterInterface["canRead"] = (item) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessgrantReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessgrantRead,
    });
  };

  public canUpdate: ContextVoterInterface["canUpdate"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessgrantUpdateany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessgrantUpdate,
    });
  };

  public canDelete: ContextVoterInterface["canDelete"] = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessgrantDeleteany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessgrantDelete,
    });
  };

  public canManage: AggregateVoterCheck = (item = {
    client: this.permissionService.defaultClient,
    location: this.permissionService.defaultLocation,
  }) => {
    return this._canCrud({
      item,
      globalAttribute: [
        PermissionAttributesEnum.GlobalOperationAccessgrantCreateany,
        PermissionAttributesEnum.GlobalOperationAccessgrantUpdateany,
        PermissionAttributesEnum.GlobalOperationAccessgrantDeleteany,
      ],
      contextAttribute: [
        PermissionAttributesEnum.ContextOperationAccessgrantCreate,
        PermissionAttributesEnum.ContextOperationAccessgrantUpdate,
        PermissionAttributesEnum.ContextOperationAccessgrantDelete,
      ],
    });
  };

  /**
   * Whether access on one user group, property or report topic may be read. The key counts on the
   * list itself, on its location and on its client.
   */
  public canReadOnList(list: CrudArgs & { "@id": string }, scope: Exclude<PermissionScope, PermissionScope.GLOBAL>): boolean {
    return this._canCrud({
      item: list,
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessgrantReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessgrantRead,
      scope,
    });
  }

  public canAccess(item?: CrudArgs): boolean {
    return this._canCrud({
      item: item ?? {
        client: this.permissionService.defaultClient,
        location: this.permissionService.defaultLocation,
      },
      globalAttribute: PermissionAttributesEnum.GlobalOperationAccessgrantReadany,
      contextAttribute: PermissionAttributesEnum.ContextOperationAccessgrantRead,
    });
  }
}
